import React from 'react';
import { Grid } from '@material-ui/core';
import AuthStar from '../../../assets/images/authstarticon.png';
// import AuthBanner from '../../../assets/images/authbanner.png';
import amazonverified_badge from '../../../assets/images/amazonverified_badge.png';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';

function RightContent() {
  return (
    <Grid item lg={6} md={12} sm={12} xs={12} className="auth_view_img_bg">
      <div className="slogan-container slogan-image-holder ">
        <div className="slogan-center" style={{ marginBottom: '0' }}>
          <img src={AuthStar} style={{ width: '60px' }} />
          <div className="slogan-center-big">Take your Amazon business to next level.</div>
          <div className="slogan-sm-offer">
            <div className="slogan-sm-offer-single">
              <CheckCircleOutlineRoundedIcon />
              <div>7 days free trial.</div>
            </div>
            <div className="slogan-sm-offer-single">
              <CheckCircleOutlineRoundedIcon />
              <div>No credit card needed.</div>
            </div>
          </div>
          <div className="amazonVerified_widget">
            <div>
              Verified as <br />
              Amazon Partner
            </div>
            <div style={{ display: 'flex' }}>
              <img src={amazonverified_badge} style={{ width: '98px' }} />
            </div>
          </div>
          <div className="stats_widget">
            <div className="stats_widget_single">
              <div className="stats_widget_number">1M+</div>
              <div className="stats_widget_text">Bids Optimized</div>
            </div>
            <div className="stats_widget_single stats_widget_center">
              <div className="stats_widget_number">200M+</div>
              <div className="stats_widget_text">Total Revenue</div>
            </div>
            <div className="stats_widget_single">
              <div className="stats_widget_number">200K+</div>
              <div className="stats_widget_text">Campaigns</div>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
}
export default RightContent;
